module.exports = __webpack_public_path__ + "img/volume_un_mute.5641b007.svg";